import * as React from "react";
import EndTurnSummary from "src/components/EndTurnSummary";
import { displayErrorToast } from "src/components/shared/Toasts/Toast";
import {
  ShowCardsButton,
  TaskCard,
  TaskCardLabel,
  TaskName,
} from "src/components/Table/TaskBoard/TaskBoard.components";
import { ToastIds } from "src/enums/errorToastIds";
import { ShowCards } from "src/enums/showCards";
import { useGameContext } from "src/game/useGameContext";
import { TaskModel } from "src/models/task/task.model";
import { VoteRevealModel } from "src/socket/events/VoteReveal/voteReveal.model";
interface Props {
  task?: TaskModel;
  voteReveal?: VoteRevealModel;
  hasUserPickedCard: boolean;
}

const UserTaskBoard: React.FunctionComponent<Props> = ({
  task,
  voteReveal,
}) => {
  const { gameState, actionHandlers } = useGameContext();
  const handleShowCards = async () => {
    if (!gameState.game?.id || !gameState.token) {
      return;
    }

    const authData = {
      gameId: gameState.game?.id,
      token: gameState.token,
    };
    try {
      const response = await actionHandlers.revealVotes(authData);
      if (response.error) {
        displayErrorToast(
          `Failed to reveal votes ${response.error.message}`,
          ToastIds.REVEAL_VOTES_FAILED
        );
      }
    } catch (e) {
      displayErrorToast("Failed to reveal votes", ToastIds.REVEAL_VOTES_FAILED);
    }
  };

  const usersCanShowCards = gameState.game?.showCards === ShowCards.EVERYONE;

  return (
    <>
      <TaskName>{task?.description}</TaskName>
      {!voteReveal?.finalResult ? (
        <EndTurnSummary />
      ) : (
        <>
          <TaskCard>{voteReveal.finalResult}</TaskCard>
          <TaskCardLabel>Final result</TaskCardLabel>
        </>
      )}
      {!voteReveal && usersCanShowCards && gameState.game?.task && (
        <ShowCardsButton themeColor="buttonPrimary" onClick={handleShowCards}>
          Show cards
        </ShowCardsButton>
      )}
    </>
  );
};

export default UserTaskBoard;
